/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

const NOTIFICATION_KEY = "action";

export const MESSAGES = {
  loading: "D3x AI agent is working on your request.",
  hotelNotConfigured:
    "This email address is not configured in D3x. Please email info@d3x.ai to get started!. For more details visit https://www.d3x.ai",
  hotelDisabled:
    "AI draft responses for this email address has been disabled in D3x. Please email support@d3x.ai if you need assistance.",
  defaultError: "An error occurred. Please try again.",
};

export function showNotification(text, callback, options = {}) {
  const params = [
    NOTIFICATION_KEY,
    {
      type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
      message: text,
      icon: "Icon.80x80",
      persistent: true,
      ...options,
    },
  ];

  if (callback) {
    params.push(callback);
  }

  Office.context.mailbox.item.notificationMessages.replaceAsync(...params);
}

export function showError(error, callback) {
  console.error(error);
  showNotification(MESSAGES.defaultError, callback);
}

export function clearNotifications(callback) {
  Office.context.mailbox.item.notificationMessages.removeAsync(NOTIFICATION_KEY, callback);
}
